import { Link, Outlet } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import Loginimage from "../../assets/images/succcess.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";

const Addmoney = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <Link to="/account">
              <button className="back-button backbutton">
                <IoIosArrowRoundBack size={30} color="white" />
              </button>
            </Link>
            <div>Add Money</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>
          <Container className="mt-3 px-3 pagewrap">
            <div className="card p-3 mb-3 shadow-sm border-0">
              <div className="mb-0">
                <label className="form-label">Add Money</label>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">₹</InputGroup.Text>
                  <Form.Control
                    placeholder="Enter Amount"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </InputGroup>
              </div>
              <div className="mb-">
                <Button
                  className="btn btn-brand-1 w-100 font-bold"
                  style={{ textTransform: "none" }}
                  onClick={handleClickOpen}
                >
                  Add Money
                </Button>
              </div>
            </div>
            {/* Phone Number Input */}
          </Container>
        </div>

        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm" // Set the max width (you can use 'xs', 'sm', 'md', 'lg', 'xl')
            fullWidth 
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="text-center">
                <img src={Loginimage} width="78" height={78} alt="Logo" />
                <br></br>
                <h5 className="text-dark mt-3 font-bold"> Money Added</h5>
                successfully added.
              </DialogContentText>
              <Link to="/account" className="mt-3 d-block">
                <Button autoFocus className="w-100 btn btn-brand-1 font-bold">
                  OK
                </Button>
              </Link>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </Container>
    </>
  );
};

export default Addmoney;
